import { Component, OnInit } from '@angular/core';
import { ROUTE_CONFIGS } from '../utility/configs/routerConfig';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../utility/services/language/language.service';
import { ConfigService } from '../utility/services/common/config.service';
import { LstorageService } from '../utility/services/common/lstorage.service';
import { LSkeys } from '../utility/configs/app.constants';
import { ChangeDetectorRef } from '@angular/core';
import { AuthenticationService } from '../utility/services/authentication/authentication.service';
import { Observable, Subject, takeUntil } from 'rxjs';
import { User } from '../utility/models/api/customer.model';
import { LoaderService } from '../utility/services/common/loader.service';
import { SocketService } from '../utility/services/common/socket.service';


interface Language {
  label: string;
  value: string;
}
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})
export class NavbarComponent implements OnInit {
  title!: "Bring It Now Customer Dispatch";
  menusidebarVisible: boolean = false;
  signInModal: boolean = false;
  currentRoute: string = '';
  languages: Language[] = [
    { label: 'English', value: 'en' },
    { label: 'español', value: 'es' },
    { label: 'français', value: 'fr' },
    { label: 'العربية', value: 'ar' }
  ];
  isLoggedIn: boolean = false;
  isMenuOpen: boolean = false;
  items: string = '';

  navbarMenu: {
    label: string,
    route: string | null,
    exact: boolean,
    // action?: () => void,
  }[];

  selectedLanguage = this.languages[0].value;
  items1: { items: { label: string; icon?: string; command?: () => void }[] }[] = [];
  profileImage: string | undefined;
  userFirstName: string | undefined;
  isLoggedIn222: boolean = false;
  userInfo$: Observable<User | null>;
  userImage$: Observable<string | null>;
  translatedItems1: any[] = [];
  private destroy$ = new Subject<void>();
  isLoader: boolean = false;

  constructor(
    private router: Router,
    private translate: TranslateService,
    private languageService: LanguageService,
    private configServ: ConfigService,
    private LstorageServ: LstorageService,
    private cdr: ChangeDetectorRef,
    private authService: AuthenticationService,
    public loaderServ: LoaderService,
    private socketServ: SocketService
  ) {
    this.navbarMenu = [
      { label: 'FAQS_LABEL', route: ROUTE_CONFIGS.FAQS, exact: false },
      { label: 'HELP_LABEL', route: ROUTE_CONFIGS.HELP_ROUTE, exact: false },
      { label: 'LANGUAGE_LABEL', route: null, exact: false },
    ];
    this.userInfo$ = this.configServ.userInfo$;
    this.userImage$ = this.configServ.userImage$;
  }

  ngOnInit(): void {
    const currentUrl = this.router.url;
    const isResetPasswordUrl = currentUrl.startsWith('/authentication/resetPassword')

    let tokenExists = !!this.LstorageServ.getItem(LSkeys.AUTH_TOKEN);
    const access_token = this.LstorageServ.getItem(LSkeys.AUTH_TOKEN);
    this.socketServ.initSocket(access_token);
    if (!tokenExists && !isResetPasswordUrl) {
      this.router.navigate([ROUTE_CONFIGS.LANDING]);
      // this.signInModal = true;
    } else {
      this.isLoggedIn = true;
      this.authService.setLoggedInState(true);
    }
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.checkLoginStatus();
      }
    });
    this.currentRoute = this.router.url;
    this.router.events.subscribe(() => {
      this.currentRoute = this.router.url;
    });

    this.languageService.currentLanguage$.subscribe(language => {
      this.selectedLanguage = language;
      this.translate.use(language);
    });
    this.isLoggedIn = !!this.LstorageServ.getItem(LSkeys.AUTH_TOKEN);
    this.items1 = [
      {
        items: [
          {
            label: 'MANAGE_ACCOUNT',
            icon: 'pi pi-user-edit',
            command: () => {
              this.router.navigate([ROUTE_CONFIGS.MANAGE_ACCOUNT_ROUTE]);
            },
          },
          {
            label: 'MY_ORDERS',
            icon: 'pi pi-bookmark-fill',
            command: () => {
              this.router.navigate([ROUTE_CONFIGS.MY_ORDERS_ROUTE]);
            },
          },
          {
            label: 'LOGOUT',
            icon: 'pi pi-sign-out',
            command: () => {
              this.logout();
            },
          }
        ]
      }
    ];
    this.updateMenuItems();
    this.translate.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.updateMenuItems();
    });

    this.loaderServ.getLoaderStatus().subscribe(val => {
      this.isLoader = val
      this.cdr.detectChanges();
    });
  }

  checkLoginStatus() {
    this.isLoggedIn = !!this.LstorageServ.getItem(LSkeys.AUTH_TOKEN);
    this.cdr.detectChanges();
  }

  isProfileRoute(): boolean {
    return this.router.url.includes('/customer/account/profile');
  }


  isLoginRoute(): boolean {
    return this.currentRoute === ROUTE_CONFIGS.LOGIN_ROUTE || this.currentRoute === ROUTE_CONFIGS.CUSTOMER_BOOKING_ROUTE || this.currentRoute === ROUTE_CONFIGS.ORGANIZATION_ROUTE;
  }

  //sign in modal open
  signInDialog() {
    this.signInModal = true;
    // this.router.navigate([ROUTE_CONFIGS.LOGIN_ROUTE]);
  }
  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  // Method to handle login button
  individualLogin(): void {
    this.router.navigate([ROUTE_CONFIGS.LOGIN_ROUTE]);
    this.signInModal = false;
  }

  organisationLogin(): void {
    this.router.navigate([ROUTE_CONFIGS.LOGIN_ROUTE], { queryParams: { organisation: true } });
    this.signInModal = false;
  }

  changeLanguage(languageCode: string) {
    this.selectedLanguage = languageCode;
    this.configServ.setLanguage(languageCode);
  }
  navigateHome() {
    const tokenExists = !!this.LstorageServ.getItem(LSkeys.AUTH_TOKEN);
    const accountStep = this.LstorageServ.getItem(LSkeys.ACCOUNT_STEP);
    if (tokenExists) {
      if (accountStep === '2') {
        this.router.navigate(['/customer/booking']);
      } else {
        this.router.navigate(['/']);
      }
    } else {
      this.router.navigate(['/']);
    }
  }

  logout() {
    const access_token = this.LstorageServ.getItem(LSkeys.AUTH_TOKEN);
    if (access_token) {
      this.authService.logout({ token: access_token }).subscribe(
        res => {
          this.LstorageServ.clear();
          this.authService.setLoggedInState(false);
          this.socketServ.disconnectSocket();
          this.router.navigate([ROUTE_CONFIGS.LANDING]);
        },
        error => {
          // console.error('Logout failed', error);
        }
      );
    } else {
      // console.error('No access token found');
    }
  }

  fetchUserData() {
    const authToken = this.LstorageServ.getItem(LSkeys.AUTH_TOKEN);
    let payload = {
      'category_id': 4,
      'latitude': 0,
      'longitude': 0,
      'distance': 4,
      'access_token': authToken
    }
    this.authService.customerDetails(payload).subscribe(
      res => {
        this.profileImage = res?.result?.data?.Details?.user?.profile_image ? res?.result?.data?.Details?.user?.profile_image : 'https://www.gravatar.com/avatar/05dfd4b41340d09cae045235eb0893c3?d=mp';
        this.userFirstName = res?.result?.data?.Details?.user?.firstName
      },
      error => {
        // console.error('Logout failed', error);
      }
    );
  }

  updateMenuItems() {
    this.translatedItems1 = this.items1?.map((group) => ({
      ...group,
      items: group.items?.map((item) => ({
        ...item,
        label: this.translate.instant(item.label || ''),
      })),
    }));
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  isExternalLink(url: string): boolean {
    return url.startsWith('http') || url.startsWith('www');
  }

}
